import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ServicePacklist(props) {
  let loadingProductData = false;
  let productData = (props.machine.productData ?? []);

  let categoryNames = {
    '291815015046972850': 'Heiß',
    '291815120424666548': 'Kalt',
    '291815240398538165': 'Snack',
    '291815298430928310': 'Frisch',
    '291815398993561015': 'Pfand',
    '291815481914951096': 'Eis',
    '291815547329316281': 'Sonstiges',
  };

  const [productContent, setProductContent] = useState(
    <div className="ui basic loading segment">
      <div className="ui placeholder">
        <div className="paragraph">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );

  // const updateProduct = (materialId, amount) => {
  //   Object.entries(productData).forEach(([key, product]) => {
  //     if (product.material_id == materialId) {
  //       productData[key].refill_amount = Math.round(Math.min(Math.max(amount, 0), product.max_amount - (product.current_amount - product.take_back_amount)));
  //     }
  //   });
  //   updateProductData();
  //   props.service.extraData = productData;
  //   props.updateExtraData(productData);
  // }

  // const updateProductCurrent = (materialId, amount) => {
  //   Object.entries(productData).forEach(([key, product]) => {
  //     if (product.material_id == materialId) {
  //       productData[key].current_amount = Math.round(Math.min(Math.max(amount, 0), product.max_amount - product.refill_amount));
  //     }
  //   });
  //   updateProductData();
  //   props.service.extraData = productData;
  //   props.updateExtraData(productData);
  // }

  // const updateBestBefore = (materialId, bestBefore) => {
  //   Object.entries(productData).forEach(([key, product]) => {
  //     if (product.material_id == materialId) {
  //       productData[key].best_before = bestBefore;
  //     }
  //   });
  //   updateProductData();
  //   props.service.extraData = productData;
  //   props.updateExtraData(productData);
  // }

  const sorter = (sortBy) => (a, b) => a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;
  const sorterReverse = (sortBy) => (a, b) => a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;


  const toggleAll = () => {
    let state = !document.querySelector('input[type="checkbox"').checked ?? false;
    Object.entries(productData).forEach(([pkey, product]) => {
      product.pack = state;
      productData[pkey] = product;
    });
    document.querySelectorAll('input[type="checkbox"').forEach((el) => {
      el.checked = state;
    });
  }

  const getTradeUnits = (missingAmount, tradeUnitContent, tradeUnitWastage) => {
    let tradeUnits = 0;
    if (tradeUnitContent <= 1.0) return missingAmount;
    let tradeUnitThreshold = tradeUnitContent * (100.0 - tradeUnitWastage) / 100.0;
    if (missingAmount < tradeUnitThreshold) return tradeUnits;
    tradeUnits = Math.floor(missingAmount / tradeUnitContent);
    if (missingAmount - tradeUnits * tradeUnitContent > tradeUnitThreshold) tradeUnits++;
    return tradeUnits;
  }

  const setProductPack = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const id = target.dataset.product;
    Object.entries(productData).forEach(([pkey, product]) => {
      if (product['base_material_id'] === id) {
        product.pack = value;
        productData[pkey] = product;
      }
    });
    updateProductData();
  }

  const displayproductRows = (productEntries) => {
    let productRows = [];
    productEntries.forEach((product) => {
      if (product.rounded_amount == undefined || product.rounded_amount <= 0) return;
      let choice = '---';
      if (product.choices.length > 0) {
        product.choices.sort();
        choice = product.choices[0];
        if (product.choices.length > 1) choice = choice + '*';
      }
      productRows.push(<tr><td><input type="checkbox" defaultChecked={product.pack === undefined || product.pack === true ? 'checked' : ''} data-product={product.base_material_id} onChange={setProductPack} /></td><td>{choice}</td><td>{product.name}</td><td style={{ textAlign: 'right' }}>{Math.round(product.rounded_amount / product.trade_unit_content)}</td></tr>);
    });
    return productRows;
  }

  const updateProductData = (freshLoad = false) => {
    let packlistType = props.userOptions.packlist ?? 'category';
    let productRows = [];
    let sortedProductData = {};
    if (packlistType == 'category') {
      Object.entries(productData).forEach(([pkey, product]) => {
        if (sortedProductData[product['category_id']] == undefined) {
          sortedProductData[product['category_id']] = [];
        }
        if (sortedProductData[product['category_id']][product['base_material_id']] == undefined) {
          sortedProductData[product['category_id']][product['base_material_id']] = product;
        }
        if (sortedProductData[product['category_id']][product['base_material_id']]['rounded_amount'] == undefined || !freshLoad) sortedProductData[product['category_id']][product['base_material_id']]['rounded_amount'] = 0;
        if (props.spontaneous || product['current_amount'] <= product['trade_unit_fill_threshold']) {
          sortedProductData[product['category_id']][product['base_material_id']]['rounded_amount'] += getTradeUnits(product['max_amount'] - product['current_amount'], product['trade_unit_content'], product['trade_unit_wastage']) * product['trade_unit_content'];
        }
      });
      Object.entries(sortedProductData).forEach(([productCategoryId, productCategoryData]) => {
        let productEntries = Object.values(productCategoryData);
        productEntries.sort(sorter('name'));
        let categoryRows = displayproductRows(productEntries);
        if (categoryRows.length > 0) {
          productRows.push(<tr className='blue'><td colSpan="4">{categoryNames[productCategoryId] ?? 'Unbekannt'}</td></tr>);
          productRows = productRows.concat(categoryRows);
        }
      });
    }
    else {
      Object.entries(productData).forEach(([pkey, product]) => {
        if (sortedProductData[product['base_material_id']] == undefined) {
          product.firstChoice = '';
          if (product.choices.length > 0) {
            product.choices.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
            product.firstChoice = product.choices[0];
          }
          sortedProductData[product['base_material_id']] = product;
        }
        if (sortedProductData[product['base_material_id']]['rounded_amount'] == undefined || !freshLoad) sortedProductData[product['base_material_id']]['rounded_amount'] = 0;
        if (props.spontaneous || product['current_amount'] <= product['trade_unit_fill_threshold']) {
          sortedProductData[product['base_material_id']]['rounded_amount'] += getTradeUnits(product['max_amount'] - product['current_amount'], product['trade_unit_content'], product['trade_unit_wastage']) * product['trade_unit_content'];
        }
      });

      let productEntries = Object.values(sortedProductData);
      productEntries.sort(sorterReverse('firstChoice'));
      productRows = productRows.concat(displayproductRows(productEntries));
    }

    setProductContent(
      <table className="ui unstackable celled very compact single line table packlist">
        <thead>
          <tr>
            <th><a onClick={e => toggleAll()}><i className='check square outline icon'></i></a></th>
            <th><i className='th icon'></i></th>
            <th>Produkt</th>
            <th><i className='dolly icon'></i></th>
          </tr></thead>
        <tbody>
          {productRows}
        </tbody>
      </table>
    );

  }

  useEffect(() => {
    if (productData.length == 0 && !loadingProductData) {
      loadingProductData = true;
      axios.post(process.env.REACT_APP_CUSTOM_URL + 'getProductData', { machineId: props.machine.id }).then(response => {
        productData = response.data.products;
        props.updateExtraData(productData);
        props.service.extraData = productData;
        updateProductData(true);
      }).catch(function (error) {
        setProductContent(<div className="ui negative message">
          <div className="header">
            Fehler
          </div>
          <p>Die Produktdaten konnten nicht geladen werden</p>
        </div>);
      });
    }
    else {
      updateProductData(false);
    }
  }, []);

  return (
    <div>
      {productContent}
    </div>
  );
}